import type {
  OutcomeReason,
  OutcomeReasonAnswer,
  OutcomeReasonKey,
  OutcomeReasonPayload,
} from "@/types/outcome-reason";

import { OUTCOME_REASON_KEY_OPTIONS } from "@/features/clinic/constants/appointments";

const NO_BOOKING: OutcomeReasonAnswer[] = [
  "not_interested",
  "nothing_booked",
  "wont_come",
];

const ALL_DONE_KEYS = new Set<OutcomeReasonKey>([
  "treatment_complete",
  "advice_only",
]);

let reasons: OutcomeReason[] = OUTCOME_REASON_KEY_OPTIONS.map(
  ({ value: key, label }, index) => ({
    id: `mock-outcome-reason-${index + 1}`,
    label,
    key,
    answers: ALL_DONE_KEYS.has(key) ? ["all_done"] : NO_BOOKING,
    createdAt: new Date(2026, 0, 1).toISOString(),
  }),
);

export function getOutcomeReasonsMock(): OutcomeReason[] {
  return reasons;
}

export function findOutcomeReasonMock(id: string): OutcomeReason | undefined {
  return reasons.find((reason) => reason.id === id);
}

export function createOutcomeReasonMock(
  payload: OutcomeReasonPayload,
): OutcomeReason {
  const reason: OutcomeReason = {
    id: `mock-outcome-reason-${Date.now()}`,
    label: payload.label,
    key: null,
    answers: payload.answers,
    createdAt: new Date().toISOString(),
  };

  reasons = [...reasons, reason];

  return reason;
}

export function updateOutcomeReasonMock(
  id: string,
  payload: Partial<OutcomeReasonPayload>,
): OutcomeReason {
  const existing = findOutcomeReasonMock(id);

  if (!existing) throw new Error("Outcome reason not found");

  const updated = { ...existing, ...payload };

  reasons = reasons.map((reason) => (reason.id === id ? updated : reason));

  return updated;
}

export function deleteOutcomeReasonMock(id: string): boolean {
  reasons = reasons.filter((reason) => reason.id !== id);

  return true;
}
